import { render, staticRenderFns } from "./FeeDataTable.vue?vue&type=template&id=6058746a&scoped=true&"
import script from "./FeeDataTable.vue?vue&type=script&lang=js&"
export * from "./FeeDataTable.vue?vue&type=script&lang=js&"
import style0 from "./FeeDataTable.vue?vue&type=style&index=0&id=6058746a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058746a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VContainer,VDataTable,VIcon,VRow,VSwitch})
